// extracted by mini-css-extract-plugin
export default {"sidebar":"MenuCategories_sidebar__Q+tib","menuBox":"MenuCategories_menuBox__-YJav","menuBox_close":"MenuCategories_menuBox_close__l3f9V"};